<template>
  <div class="carousel__cell" :style="style" @click="click">
    <div class="carousel__cell__inner" :style="styleInner"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    deg: {
      type: Number,
      default: 0,
    },
    offset: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    src: String,
    to: String,
    click: Function,
  },
  computed: {
    style(): {
      [key: string]: string;
    } {
      return {
        transform: `rotateY(${this.deg}deg) translateZ(-${this.offset}px)`,
        width: `${this.width}px`,
        height: `${this.height}px`,
      };
    },
    styleInner(): {
      [key: string]: string;
    } {
      return {
        backgroundImage: `url('${this.src}')`,
        backgroundSize: `cover`,
      };
    },
  },
});
</script>

<style scoped>
.carousel__cell {
  position: absolute;
  background: transparent;
  backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000;
  pointer-events: all;
}
.carousel__cell__inner {
  width: 100%;
  height: 100%;
  /* transform-origin: left center; */
  transform-origin: center center;
  transition: transform 0.5s linear;
  transform-style: "preserve-3d";
  box-shadow: 0 0 20px 0px rgba(255, 255, 255, 0.5);
}
.carousel__cell__inner:hover {
  cursor: pointer;
  /* transform: rotateY(70deg); */
  transform: scale(1.05);
}
</style>
